import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { StateNewsLetterParams } from "../types/newsLetter/newsLetterParams";

interface newsLetterInitialStateParams {
    isLoading: boolean;
    getAllNewsLetter: StateNewsLetterParams[];
    currentPage: number;
    numberOfPages: number;
    totalNumber: number;
}

const initialState: newsLetterInitialStateParams = {
    isLoading: true,
    getAllNewsLetter: [],
    currentPage: 1,
    numberOfPages: 0,
    totalNumber: 0,
}

const newsLetterSlice = createSlice({
    name: 'NEWSLETTER',
    initialState,
    reducers: {
        startLoading: (state) => {
            state.isLoading     = true;
        },
        endLoading: (state) => {
            state.isLoading     = false;
        },
        setNewsLetter: (state, action) => {
            state.getAllNewsLetter    = action.payload.data;
            state.currentPage         = action.payload.currentPage;
            state.numberOfPages       = action.payload.numberOfPages;
            state.totalNumber         = action.payload.totalNumber;
        },
    }
});

export const { startLoading, endLoading, setNewsLetter } = newsLetterSlice.actions
export default newsLetterSlice.reducer
